import { ApplyToTrialButton } from '@components/app/Button/ApplyToTrial/index.client'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import { utcDateString } from '@lib/utilities/date/utcDateString'
import { type ClinicalTrialForListingPage } from '@modules/trials/helpers/fragments/clinicalTrialListingFragment'
import { getSpotsRemaining } from './helpers'

export const FloatingApplyCta = ({
  className,
  ctaColor,
  trial,
}: {
  className?: string
  ctaColor: 'primary' | 'black'
  trial: Pick<
    ClinicalTrialForListingPage,
    | 'enrollmentCount'
    | 'nctId'
    | 'overallStatus'
    | 'primaryCompletionDate'
    | 'slug'
    | 'studyStartDate'
  >
}) => {
  const monthYear = {
    month: 'short',
    timeZone: 'UTC',
    year: 'numeric',
  } as const

  const { endDate, spotsRemaining } = getSpotsRemaining({
    enrollmentCount: trial.enrollmentCount,
    primaryCompletionDate: trial.primaryCompletionDate,
    studyStartDate: trial.studyStartDate,
  })

  return (
    <div
      className={classMerge(
        'fixed bottom-[-100%] left-0 z-mobileTrialApplyButton flex w-full items-center justify-between border-t border-neutral300 bg-white p-4 md:hidden',
        className,
      )}
      style={{ transition: 'bottom 1.5s' }}
    >
      <div>
        <Text
          styleName='p-small-strong'
          value={`~${spotsRemaining} spots left`}
        />
        <Text
          styleName='p-tiny'
          value={`by ${utcDateString(endDate, monthYear)}`}
        />
      </div>
      <div className='w-[210px]'>
        <ApplyToTrialButton
          color={ctaColor}
          source={TrackingSources.FLOATING_MOBILE_CTA}
          trial={trial}
        />
      </div>
    </div>
  )
}
